module.exports = __webpack_public_path__ + "static/media/11-Wimbledon-Village.e94d9ac6.mp4";